<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>

          <LibraryItems rightPanelId="sidebar-new-datasource" organizationScopedState="organizationDatasource" libraryScopedState="datasource" :hideCategoryFilter="true" />
        </b-tab>

        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("datasource.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('datasource.name')"
            :label="$t('datasource.name')"
          />

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>

      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("datasource.new") }}</span>
        </h2>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('datasource.name')"
          :label="$t('datasource.name')"
        />

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
      </div>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: ["hide-library"],
  components: {
    LibraryItems,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationDatasource/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationDatasource/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationDatasource/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationDatasource/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationDatasource/isCoping"];
    },
  },
  mounted() {},
  methods: {
    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("organizationDatasource/save", this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.dispatch("organizationDatasource/resetForm");
    },
  },
};
</script>
